/* eslint-disable no-undef */
import React, { useContext } from 'react';
import { connect } from 'react-redux';

import { openLinkObjectModal, canLinkMultipleObjects } from 'actions/modalActions';
import LocaleContext from 'constants/localization';

// Added during SPEC-40, open modal to search objects for linking
const ResourceLinkEdit = ({ field, parentUri, 
  searchParameters, openLinkObjectModal }) => {
  const LS = useContext(LocaleContext);

  if (!searchParameters) {
    return null;
  }

  const { label, predicate } = field;

  // Overridden by values in searchParameters prop
  const defaultParameters = {
    style: 'simple',
    predicateUri: predicate,
    prevShowFolderMenu: false,
    forceExecute: true,
    //delimiter for noSearchForViews variable is ';' 
    noSearchForViews: 'object',
	windowId: sessionStorage.getItem('WINDOW_ID'),
  };
  
  // allow all results with no toplevel (same as searching FT "*")
  if (!searchParameters?.topLevel) {
    defaultParameters.searchAll = true;
  }

  const parameters = Object.assign({}, defaultParameters, searchParameters);

  const urlParameters = new URLSearchParams();

  for (const [key, value] of Object.entries(parameters)) {
    if (Array.isArray(value)) {
      value.map(v => urlParameters.append(key, v));
    } else {
      urlParameters.append(key, value);
    }
  }
  let windowId = sessionStorage.getItem('WINDOW_ID');
  if (!windowId) {
    windowId = Date.now();
    sessionStorage.setItem('WINDOW_ID');
  }
  urlParameters.append('windowId', windowId);

  let searchUri = 'linkSearch.do?' + urlParameters.toString();

  const onAdd = () => openLinkObjectModal({
    predicate,
    parentUri,
    searchUri,
    linkMultpleObjects: canLinkMultipleObjects(predicate),
    label: `${LS.actions.link} ${label}`,
    onSave: value => { [].concat(value).forEach(v => field.addValue(v));}
  });

  return (
    <button
      style={{ marginTop: '0.5rem' }}
      type="button" 
      disabled={field.values.length >= field.props.maxOccurs} 
      onClick={onAdd}>
      {LS.actions.search} {label}
    </button>
  );
};

export default connect(null, { openLinkObjectModal })(ResourceLinkEdit);